import { Fragment } from "react";
import { useAppContext } from "../../context";

function renderLineWithStrikes(line: string) {
	const segments: { type: "text" | "strike"; value: string }[] = [];
	let lastIndex = 0;
	const re = /\|s\|(.+?)\|\/s\|/g;
	let match: RegExpExecArray | null;
	while ((match = re.exec(line)) !== null) {
		if (match.index > lastIndex) {
			segments.push({ type: "text", value: line.slice(lastIndex, match.index) });
		}
		segments.push({ type: "strike", value: match[1] });
		lastIndex = re.lastIndex;
	}
	if (lastIndex < line.length) {
		segments.push({ type: "text", value: line.slice(lastIndex) });
	}
	if (segments.length === 0) return line;
	if (segments.length === 1 && segments[0].type === "text") return segments[0].value;
	return (
		<>
			{segments.map((seg, i) =>
				seg.type === "text" ? (
					<Fragment key={i}>{seg.value}</Fragment>
				) : (
					<span key={i} className="line-through">
						{seg.value}
					</span>
				)
			)}
		</>
	);
}


interface FruitData {
    born?: string;
    age?: string;
    achivment?: string;
    hard?: string;
    icon: React.FC<React.SVGProps<SVGSVGElement>>;
    iconPos: string;
    margin?: number;
}



const resumeLabels: Record<string, string> = {
    born: 'Обо мне',
    age: 'Возраст',
    achivment: 'Достижения',
    hard: 'Хард-скилл'
};


export const Resume = ({ data }: any) => {
    const { isMobile } = useAppContext();

    const keys = Object.keys(data).filter(key => key !== 'icon' && key !== 'iconPos' && key !== 'name') as Array<keyof FruitData>;
    return (
        <div>
            {keys.map((key: any, index) => {
                const value = data[key];
                if (!value || typeof value !== 'string' || key === 'margin') return null;
                return (
                    <div key={index}>
                        <div className={`flex items-start relative ${isMobile ? 'mb-4 gap-4' : 'mb-6 gap-6'} ${Boolean(index) ? isMobile ? 'mt-4' : 'mt-6' : ''}`} key={index}>
                            <p className={`text-cgrey whitespace-nowrap  ${isMobile ? 'short:text-[14px]/[14px] text-[16px]/[16px]' : 'text-[28px]/[28px]'}`}>{resumeLabels[key] || key}:</p>
                            <span className={`inline-flex flex-col items-start`}>
                                {value.split('\n').map((line, index) => {
                                    return (
                                        <span key={index + key} className={` bg-bggrey px-1  font-bold whitespace-nowrap  ${isMobile ? 'first:mt-0 short:text-[16px]/[16px] text-[17px]/[17px]' : 'text-[30px]/[30px]'}`}>
                                            {key === 'achivment' ? renderLineWithStrikes(line) : line}
                                        </span>
                                    )
                                }
                                )}
                            </span>
                        </div>
                        {index !== 2 && <div className="h-px w-full bg-[#D9D9D9]" key={key} />}
                    </div>
                );
            })}
        </div>
    );
}